import { GridSortModel } from "@mui/x-data-grid";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseContent,
} from "../../../utils/utils";
import { useQuery } from "@tanstack/react-query";
import {
  GetAllSocialHistoryQuestionsSocialHistoryTypeEnum,
  SocialHistoryQuestionsControllerApi,
} from "../../../services";

interface Props {
  socialHistoryType: GetAllSocialHistoryQuestionsSocialHistoryTypeEnum;
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  sortBy?: string;
  sortDirection?: string;
  searchString?: string;
  xTENANTID?: string | undefined;
}

export type SocialHistoryOptionData = {
  name: string;
  uuid: string;
  type: string;
  question: string;
  sequenceId: number;
  answerType: string;
};
/**
 * @author Atish Bagate
 * **/

export const useSocialHistoryQuestions = ({
  socialHistoryType,
  gridSorting,
  sortDirection,
  xTENANTID,
}: Props): useBaseContent<SocialHistoryOptionData> => {
  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "sequenceId" : undefined;

  return useQuery({
    queryKey: [
      "patient-social-history-questions-list",
      xTENANTID,
      socialHistoryType,
    ],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new SocialHistoryQuestionsControllerApi(getConfigObject())
        .getAllSocialHistoryQuestionsForPatient(
          socialHistoryType,
          0, //page,
          100, // size
          sortBy,
          sortDirection,
          xTENANTID
        )
        .then((result) => result?.data),
  });
};
